// src/utils/migrate.js
import * as storage from './storage';
import { updateUserStats, saveLogs, saveDecisions, saveChallengeState } from './userService';

export const migrateIfNeeded = async (userId, { force = false } = {}) => {
  if (!userId) throw new Error('Cannot migrate local data without a user ID');
  const migrationKey = `senditmaxx_migrated_v1:${userId}`;
  if (localStorage.getItem(migrationKey)) return;

  // Older releases used a device-wide marker. Keep existing anonymous sessions
  // from re-importing stale local data, but let an explicit new guest session
  // import the current browser cache into its new identity.
  if (localStorage.getItem('senditmaxx_migrated_v1') && !force) {
    localStorage.setItem(migrationKey, 'true');
    return;
  }

  console.log('Running one-time migration to Supabase...');
  await updateUserStats(userId, {
    username: storage.getUsername() || '',
    bio: storage.getBio() || '',
    score: storage.getScore(),
    streak: storage.getStreak(),
    longest_streak: storage.getLongestStreak(),
    badges: storage.getBadges(),
    countdown_uses: storage.getCountdownUses(),
    weekly_start_date: storage.getWeeklyStartDate(),
    onboarding_complete: storage.getOnboardingComplete(),
    visit_count: storage.getVisitCount(),
    recovery_mode: storage.getRecoveryMode(),
    last_completion: storage.getLastCompletion(),
    last_username_change: storage.getLastUsernameChange(),
    sound_enabled: storage.getSoundEnabled(),
  });

  await saveLogs(userId, storage.getLogs(), storage.getPendingOutcomes());
  await saveDecisions(userId, storage.getDecisions());

  await saveChallengeState(userId, {
    daily_challenge: storage.getDailyChallenge()?.challenge || null,
    daily_date: storage.getDailyChallenge()?.date || null,
    weekly_challenge: storage.getWeeklyChallenge(),
    weekly_completed: storage.getWeeklyCompleted(),
    weekly_start_date: storage.getWeeklyStartDate(),
  });

  localStorage.setItem(migrationKey, 'true');
  localStorage.setItem('senditmaxx_migrated_v1', 'true');
  localStorage.removeItem('senditmaxx_force_migration');
  console.log('Migration complete ✅');
};